<template>
  <transition name="fade">
    <div
      v-if="isOpen"
      class="fixed inset-0 bg-black z-50 flex items-center justify-end"
    >
      <div class="absolute top-6 right-6">
        <img
          src="../../../public/assets/icons/cross-white.svg"
          class="w-[32px] h-[32px] cursor-pointer"
          alt="Close Menu"
          @click="$emit('close-menu')"
        />
      </div>
      <div
        class="flex flex-col items-end gap-[48px] font-aktiv-grotesk-regular mr-6"
      >
        <div
          @click="navigateTo('/resources/sessions')"
          class="text-[#FFFFFF] text-[24px] font-[400] leading-[24px] cursor-pointer header-resources"
          :class="{
            'underline font-bold': $route.path === '/resources/sessions',
          }"
        >
          Resources
        </div>
        <div
          @click="goToPhotos()"
          class="text-[#FFFFFF] text-[24px] font-[400] leading-[24px] cursor-pointer header-photos"
        >
          Photos
        </div>
        <div
          @click="navigateTo('/whats-next')"
          class="text-[#FFFFFF] text-[24px] font-[400] leading-[24px] cursor-pointer header-whats-next"
          :class="{ 'underline font-bold': $route.path === '/whats-next' }"
        >
          What's Next
        </div>
        <div
          @click="openLogoutModal"
          class="flex items-center text-[#FFFFFF] text-[24px] font-[400] leading-[24px] cursor-pointer header-logout"
        >
          <img
            src="../../../public/assets/icons/log-out-white.svg"
            class="w-[24px] h-[24px] mr-[8px]"
            alt="Log Out"
          />
          <span>Log Out</span>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    navigateTo(route) {
      this.$router.push(route);
      this.$emit("close-menu");
    },
    openLogoutModal() {
      this.$emit("open-logout-modal");
    },
    goToPhotos() {
      window.open(
        "https://hogcphotographyministry.pixieset.com/generationsimplementationcommunity2/",
        "_blank"
      );
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
